import type { SVGProps } from 'react';
const SvgNoDataIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 104 104"
    {...props}
  >
    <g clipPath="url(#no_data_icon_svg__a)">
      <path
        fill="#fff"
        d="M52 104c28.719 0 52-23.281 52-52S80.719 0 52 0 0 23.281 0 52s23.281 52 52 52Z"
      />
      <path
        fill="url(#no_data_icon_svg__b)"
        d="M36.366 41.732a9.366 9.366 0 1 0 0-18.732 9.366 9.366 0 0 0 0 18.732Z"
      />
      <path
        stroke="#4458B1"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
        d="M55.488 32.756h-15.61a3.902 3.902 0 0 0-3.902 3.902v31.22a3.902 3.902 0 0 0 3.902 3.902h23.415a3.902 3.902 0 0 0 3.902-3.902V44.463L55.488 32.756Z"
      />
      <path
        stroke="#4458B1"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
        d="M55.488 32.756v11.707h11.707"
      />
      <path
        fill="#4458B1"
        d="M47.683 52.268a1.951 1.951 0 1 1-3.903 0 1.951 1.951 0 0 1 3.903 0ZM59.39 52.268a1.951 1.951 0 1 1-3.902 0 1.951 1.951 0 0 1 3.902 0ZM45.732 60.073h11.707v1.952H45.732v-1.952Z"
      />
    </g>
    <defs>
      <linearGradient
        id="no_data_icon_svg__b"
        x1={36.366}
        x2={36.366}
        y1={23}
        y2={41.732}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#4458B1" />
        <stop offset={1} stopColor="#4458B1" stopOpacity={0.2} />
      </linearGradient>
      <clipPath id="no_data_icon_svg__a">
        <path fill="#fff" d="M0 0h104v104H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgNoDataIcon;
